<template>
  <v-card>
    <v-card-title>
      <div style="cursor: pointer" @click="goToPartnersTable">Partneři</div>
      <div style="margin-right: 15px; margin-left: 15px">--></div>
      {{ data.name }}
    </v-card-title>
    <v-form @submit.prevent="updatePartnerData">
      <v-card-text>
        <v-row>
          <v-col cols="6" sm="4">
            <v-text-field disabled hide-details="auto" label="ID" v-model="data._id" outlined filled dense />
          </v-col>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" label="IČO" v-model="data.ico" outlined filled dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" label="Partner" v-model="data.name" outlined filled dense />
          </v-col>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" label="Telefonní číslo" v-model="data.phoneNumber" outlined filled dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" label="Adresa" v-model="data.address" outlined filled dense />
          </v-col>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" label="Email" v-model="data.email" outlined filled dense />
          </v-col>
        </v-row>
        <v-row v-if="!creating">
          <v-col cols="12">
            <partner-card-details :user-id="this.id"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="primary" class="mx-1" type="submit">Uložit</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import UserBlockDialog from '@/components/app/users/UserBlockDialog'
import UserCardDetails from '@/components/app/users/details/UserCardDetails'
import PartnerCardDetails from "@/components/app/partners/details/PartnerCardDetails";
import _ from "lodash-es"

export default {
  name: "PartnerCard",
  components: {
    UserCardDetails,
    UserBlockDialog,
    PartnerCardDetails
  },
  props: {
    id: {
      required: false,
      default: () => null
    },
    creating: {
      type: Boolean
    }
  },
  data() {
    return {
      data: {},
      copyData: {},
      saveModel: {}
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.axios.get('/v1/partners/' + this.id)
          .then(({data}) => {
            this.data = data
            this.copyData = {...data}
          }).catch(() => this.$router.go(-1))
    },
    getObjectDiff(obj1, obj2) {
      return Object.keys(obj1).reduce((result, key) => {
        if (!obj2.hasOwnProperty(key)) {
          result.push(key);
        } else if (_.isEqual(obj1[key], obj2[key])) {
          const resultKeyIndex = result.indexOf(key);
          result.splice(resultKeyIndex, 1);
        }
        return result;
      }, Object.keys(obj2));
    },
    updatePartnerData() {
      let diffKeys = this.getObjectDiff(this.data, this.copyData)
      let diffData = {}
      diffKeys.forEach(dataKey=>{
        diffData[dataKey] = this.data[dataKey]
      })

      this.axios.patch('/v1/partners/' + this.id, diffData)
          .then(()=>{
            this.$store.commit('addAlert', {
              type: 'success',
              message: "Úspěšně"
            })
          })
          .catch((el)=>{
            if (el.response && el.response.data && el.response.data.errors){
              el.response.data.errors.forEach((error)=>{
                this.$store.commit('addAlert', {
                  type: 'error',
                  message: error.message
                })
              })
            }else{
              this.$store.commit('addAlert', {
                type: 'error',
                message: "Chyba"
              })
            }
          })
          .finally()
    },
    goToPartnersTable() {
      this.$router.push("/app/partners")
    }
  },
  computed: {
  },
  watch: {
    data: {
      deep: true,
      handler: function (value) {
      }
    }
  }
}
</script>

<style scoped>

</style>